/**
 * Общие хелперы для калькуляторов цен — единые для бэкенда и фронтенда.
 *
 * До выноса эти примитивы повторялись дословно в каждом калькуляторе с обеих сторон
 * (бэк: project/src/utils/calcPrice.ts и др.; фронт: front/src/components/Settings/helpers/defaultCalcPrice.ts и др.):
 *   Math.max(x || 0, MIN)      — ~40 копий на бэке, ~30 на фронте
 *   Math.max(MARZA * price, MIN_CONST_PRIBL)  — 10+10 копий
 *   Math.ceil(price / (1 - SALE))             — 10+10 копий
 * Каноничные реализации — здесь.
 */

/**
 * Берёт параметр с защитой от undefined/0 и нижней границей.
 * Соответствует историческому паттерну Math.max(value || 0, min).
 * На бэке min = MIN_CALC_PARAMS.X, на фронте min = 0.
 */
export const clampParam = (value: number | undefined, min: number): number => {
  return Math.max(value || 0, min);
};

/**
 * Прибыль = максимум из маржи (доля от входной цены) и минимальной константы прибыли.
 * Соответствует PRIBL = Math.max(MARZA * price, MIN_CONST_PRIBL) во всех калькуляторах.
 */
export const calcProfit = (margin: number, price: number, minProfit: number): number => {
  return Math.max(margin * price, minProfit);
};

/**
 * Применяет скидку: цена со скидкой выше базовой, чтобы после SALE% получилась currentPrice.
 * Соответствует Math.ceil(currentPrice / (1 - SALE)) во всех калькуляторах.
 */
export const applySale = (price: number, sale: number): number => {
  return Math.ceil(price / (1 - sale));
};